<template>
  <div id="header" style="z-index: 5;">
    <div class="container header-container">
      <img
        alt="DHHQ"
        class="logo"
        :src="`/logo${$vuetify.theme.dark ? '-dark' : ''}.png`"
        @click="$router.push('/').catch(() => {})">
      <template>
        <div style="list-style: none; display: flex; align-items: center;">
          <template v-if="!mobilePhone">
            <div>
              <v-btn class="header-menu-item"
              :style="$route.name === 'senate_landing' ? `color: ${$vuetify.theme.currentTheme.text} !important` : ''" text tile small @click="$router.push('/senate').catch(() => {})">Senate</v-btn>
              <v-btn class="header-menu-item"
              :style="$route.name === 'house_landing' ? `color: ${$vuetify.theme.currentTheme.text} !important` : ''" text tile small @click="$router.push('/house').catch(() => {})">House</v-btn>
            </div>
          </template>
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn class="header-menu-item" text small v-on="on">
                More
                <v-icon right dark>mdi-chevron-down</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item v-if="mobile" @click="$router.push('/senate')">
                <v-list-item-title>Senate</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="mobile" @click="$router.push('/house')">
                <v-list-item-title>House</v-list-item-title>
              </v-list-item>
              <v-list-item @click="$router.push('/about')">
                <v-list-item-title>About</v-list-item-title>
              </v-list-item>
              <v-list-item @click="$router.push('/methodology')">
                <v-list-item-title>Methodology</v-list-item-title>
              </v-list-item>
              <v-list-item @click="openLink('https://forecast2020.decisiondeskhq.com/')">
                <v-list-item-title>2020 Forecast</v-list-item-title>
              </v-list-item>
              <v-list-item @click="openLink('https://forecast2018.decisiondeskhq.com/')">
                <v-list-item-title>2018 Forecast</v-list-item-title>
              </v-list-item>
              <v-list-item @click="openLink('https://decisiondeskhq.com/')">
                <v-list-item-title>DDHQ Blog</v-list-item-title>
              </v-list-item>
              <v-list-item @click="openLink('https://results.decisiondeskhq.com/')">
                <v-list-item-title>Results</v-list-item-title>
              </v-list-item>
              <v-list-item @click="logout" v-if="$auth.authenticated">
                <v-list-item-title>Log Out</v-list-item-title>
              </v-list-item>
              <v-list-item @click="$router.push('/login')" v-else>
                <v-list-item-title>Log In</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const name = 'fc_header'

const computed = {
  ...mapGetters({
    mobile: 'ux/mobile',
    mobilePhone: 'ux/mobilePhone'
  })
}

const methods = {
  logout () {
    this.$auth.logout()
    if ((this.$route.meta || {}).auth === true) {
      this.$router.push('/')
    }
  },
  openLink (url) {
    window.open(url, '_blank')
  }
}

export default {
  name,
  computed,
  methods
}
</script>

<style>
.header-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
}

.nav-container {
  padding-bottom: 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
}

.logo {
  cursor: pointer;
  height: 40px;
  vertical-align: middle;
}

.header-menu-item {
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
  cursor: pointer;
  color: #9e9e9e !important;
}

.header-menu-item a {
  color: #9e9e9e !important;
}

.mobile-nav-btn {
  margin: 0 5px;
}
</style>
